import React, { useState } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Dashboard from './pages/Dashboard';
import SentimentAnalysis from './pages/SentimentAnalysis';
import ServiceGaps from './pages/ServiceGaps';
import RetentionRisk from './pages/RetentionRisk';
import Performance from './pages/Performance';
import Reports from './pages/Reports';

function App() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <Router>
      <div className="flex h-screen bg-secondary-50">
        <Sidebar isOpen={sidebarOpen} setIsOpen={setSidebarOpen} />
        
        <div className="flex-1 flex flex-col overflow-hidden">
          <Header setSidebarOpen={setSidebarOpen} />
          
          <main className="flex-1 overflow-x-hidden overflow-y-auto bg-secondary-50">
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="container mx-auto px-6 py-8"
            >
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/sentiment" element={<SentimentAnalysis />} />
                <Route path="/service-gaps" element={<ServiceGaps />} />
                <Route path="/retention" element={<RetentionRisk />} />
                <Route path="/performance" element={<Performance />} />
                <Route path="/reports" element={<Reports />} />
              </Routes>
            </motion.div>
          </main>
        </div>
      </div>
    </Router>
  );
}

export default App;